import { render } from "./EditorHotspotImage.vue?vue&type=template&id=6d1595e1"
import script from "./EditorHotspotImage.vue?vue&type=script&lang=js"
export * from "./EditorHotspotImage.vue?vue&type=script&lang=js"

import "./EditorHotspotImage.vue?vue&type=style&index=0&id=6d1595e1&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__